import axios from "const/axios";

const base = "/messaging/whatsapp";

export function getWhatsAppChannel() {
  return axios.get(`${base}/channel`);
}

export function saveWhatsAppChannel(body) {
  return axios.put(`${base}/channel`, body);
}

export function getWhatsAppStatus() {
  return axios.get(`${base}/channel/status`);
}

export function sendWhatsApp(body) {
  return axios.post(`${base}/messages`, body);
}

export function sendWhatsAppBulk(body) {
  return axios.post(`${base}/messages/bulk`, body);
}

export function fetchWhatsAppBatches(params) {
  return axios.get(`${base}/logs`, { params }).then((response) => response?.data?.data);
}

export function fetchWhatsAppBatch(batchId) {
  return axios
    .get(`${base}/logs/${encodeURIComponent(batchId)}`)
    .then((response) => response?.data?.data);
}

export function fetchClientWhatsAppLogs(clientId, params) {
  return axios
    .get(`${base}/clients/${clientId}/logs`, { params })
    .then((response) => response?.data?.data);
}

export function fetchWhatsAppMessageFileUrl(messageId) {
  return axios
    .get(`${base}/messages/${messageId}/file/url`)
    .then((response) => response?.data?.data?.url);
}

export function fetchWhatsAppFileUrl(batchId, index) {
  return axios
    .get(`${base}/logs/${encodeURIComponent(batchId)}/files/${index}/url`)
    .then((response) => response?.data?.data?.url);
}

export function getClientWhatsAppMessages(clientId, params) {
  return axios.get(`${base}/clients/${clientId}/messages`, { params });
}

export function getClientWhatsAppOptIn(clientId) {
  return axios.get(`${base}/clients/${clientId}/opt-in`);
}
